
export default class DispenseReportingDto {
  id;
  marche;
  ongletReporting;
  dateDebut;
  dateFin;
  trimestreId;
  type;
  commentaire;
}